export function sendShoppingListLink(
    slug: string,
    emailAddress: string,
    locale: string
): Promise<{ success: boolean }> {
    return fetch('/api/shopping-planner/send-email/' + (slug ?? ''), {
        method: 'POST',
        body: JSON.stringify({
            recipient: emailAddress,
        }),
        headers: {
            'Accept-Language': locale,
        },
    })
        .then((response) => response.json())
        .then((response) => response.data);
}
